{
  "de": {
    "form": {
      "actions": {
        "cancel": "Abbrechen",
        "clear": "Leeren",
        "closeFullPage": "Vollbildansicht schließen",
        "copyText": "Klicken, um den Text zu kopieren",
        "create_and_attach_phase": "Erstellen und mit Phase verknüpfen",
        "create_and_send": "Erstellen und senden",
        "create_and_send_to_customer": "Erstellen und an den Kunden senden",
        "create_and_share": "Erstellen und mit dem Kunden teilen",
        "create_and_share_partners_only": "Erstellen und mit Partner(n) teilen",
        "create_and_share_with_partners": "Erstellen und mit Kunden und Partner(n) teilen",
        "next": "Weiter",
        "only_create": "Nur erstellen",
        "openFullPage": "In Vollbildansicht öffnen",
        "save": "Speichern",
        "saveChanges": "Änderungen speichern",
        "save_as_draft": "Als Entwurf speichern",
        "search": "Suche...",
        "send": "Senden",
        "send_and_create_another": "Senden und weitere erstellen",
        "send_to_customer": "An den Kunden senden",
        "share_with_customer": "Mit dem Kunden teilen",
        "submit": "Absenden",
        "submit_and_create_another": "Absenden und weitere erstellen"
      },
      "back": "Vorheriger Schritt",
      "labels": {
        "columns": "Spalten",
        "from": "Von",
        "no_results": "Keine Ergebnisse",
        "optional": "(optional)",
        "to": "Bis"
      },
      "notifications": {
        "textHasBeenCopied": "Text wurde kopiert"
      },
      "password": "Passwort",
      "send_moment": {
        "attach_failed": "Erstellt, aber nicht mit der Phase verknüpft. Verknüpfen Sie es im Workflow erneut.",
        "concept_description": "Niemand sieht etwas. Sie senden es später selbst oder verknüpfen es doch noch mit einer Phase.",
        "concept_title": "Als Entwurf speichern",
        "item_decision": "diese Entscheidung",
        "item_survey": "diese Umfrage",
        "item_todo": "diese Aufgabe",
        "now_description_decision": "Die Kunden der ausgewählten Einheiten erhalten die Entscheidung sofort, mit einer Benachrichtigung.",
        "now_description_survey": "Die Kunden der ausgewählten Einheiten erhalten die Umfrage sofort, mit einer Benachrichtigung.",
        "now_description_todo": "Die verantwortlichen Personen der ausgewählten Einheiten erhalten die Aufgabe sofort, mit einer Benachrichtigung.",
        "now_title": "Jetzt senden",
        "phase_description": "Geht pro Einheit automatisch raus, sobald diese Einheit die Phase erreicht.",
        "phase_label": "Phase",
        "phase_title": "Mit einer Phase verknüpfen",
        "title": "Wann sieht der Kunde {item}?",
        "workflow_help": "Was ist ein Workflow?",
        "workflow_help_more": "Mehr lesen",
        "workflow_help_text": "Ein Workflow sind die Phasen, die jede Einheit durchläuft. Wenn Sie etwas mit einer Phase verknüpfen, sieht der Kunde es automatisch, sobald seine Einheit diese Phase erreicht."
      },
      "shortcuts": {
        "save_mac": "⌘ + Enter zum Speichern",
        "save_windows": "Strg + Enter zum Speichern",
        "send_mac": "⌘ + Enter zum Senden",
        "send_windows": "Strg + Enter zum Senden"
      },
      "steps": "Schritt {count} von {total}",
      "writeEmployeeNameReject": "Schreiben Sie <i><b>{employeeName}</b></i>, um fortzufahren."
    }
  }
}
